import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CorrelationModule } from '@wdpr/ra-angular-correlation';

import { JsonEditorModule } from '../json-editor/json-editor.module';
import { DebugPanelComponent } from './debug-panel.component';

@NgModule({
    imports: [
        CommonModule,
        JsonEditorModule,
        CorrelationModule,
    ],
    declarations: [
        DebugPanelComponent
    ],
    providers: [],
    exports: [
        DebugPanelComponent
    ],
    entryComponents: [DebugPanelComponent]
})
export class DebugPanelModule {
    static entry = DebugPanelComponent;
}
